import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <div className="spinner-logo-container">
        <img 
          src="/centurion-logo.svg"
          alt="Centurion Boats"
          className="spinner-logo"
        />
        <div className="spinner-ring"></div>
      </div>
      <p>Loading boat inventory...</p>
    </div>
  );
};

export default LoadingSpinner;
